import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { SubscriptionSchedulerService } from 'src/app/reusables/subscription-scheduler/subscription-scheduler.service';
import { DeleteSubscriptionService, SubscriptionOptions } from './delete-subscription.service';

@Component({
    selector: 'cv-delete-subscription',
    templateUrl: './delete-subscription.component.html',
    styleUrls: ['./delete-subscription.component.scss']
})
export class DeleteSubscriptionComponent implements OnInit {
    @Output() deleted = new EventEmitter<void>();

    private modalData: SubscriptionOptions;
    public recipientEmails: string[] = [];

    constructor(
        private activeModal: NgbActiveModal,
        private cvLocalizationService: CVLocalizationService,
        private service: DeleteSubscriptionService,
        private subscriptionService: SubscriptionSchedulerService,
    ) { 
        this.modalData = this.service._getModalData();
        this.recipientEmails = this.modalData.existingSchedule.RecipientEmails;
    }

    async ngOnInit(): Promise<void> {
        await this.cvLocalizationService.GetSection('Subscription_Modal');
    }

    approve() {
        this.subscriptionService.deleteSubscriptionSchedule(this.modalData.subscriptionId);
        this.deleted.emit();
        this.activeModal.close();
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
